import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const rotation = {
  up: 180,
  down: 0,
  left: 90,
  right: 270
};
const SvgArrow = ({
  orientation = 'left',
  ...props
}) => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em",
  ...props,
  style: {
    transform: `rotate(${rotation[orientation]}deg)`,
    ...props.style
  },
  children: /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M6 8h12l-6 8z"
  })
});
export default SvgArrow;